module.exports = __webpack_public_path__ + "static/media/book-finder.2fe0a354.png";